import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

import BottomBar from "../../../ui/BottomBar";
import StepContainer from "../../../ui/StepContainer";
import StepForm from "../../../ui/StepForm";
import { STEP_STORAGE_KEYS } from "../../../constants/storageConstants";
import { projectDataPropType } from "../../../util/propTypeHelper";
import CrashModificationFactorsForm from "./CrashModificationFactorsForm";
import Header from "../../../ui/Header";
import { ROUTES } from "../../../constants/routesConstants";
import { getGlobalAreaType } from "./safetyHelpers";

export default function SafetyDefaults({ projectData, saveFormData }) {
  const navigate = useNavigate();
  const handleButtonClick = () => navigate(ROUTES.SAFETY);

  const globalAreaType = getGlobalAreaType(projectData);
  const { currentIntersection: currentIntx } =
    projectData[STEP_STORAGE_KEYS.GLOBAL_INPUT_DATA];
  return (
    <StepContainer withProgressStepper={false}>
      <StepForm
        isOnChangeMode
        onFormSubmit={handleButtonClick}
        projectData={projectData}
        saveFormData={saveFormData}
        storageKey={STEP_STORAGE_KEYS.CRASH_MODIFICATION_FACTORS}
      >
        {({ errors, formData, register, isDirty }) => {
          return (
            <>
              <Header
                subtitle="Allows override of default crash modification factors for selected intersections"
                title="Safety Defaults"
              />
              <CrashModificationFactorsForm
                currentIntx={currentIntx}
                errors={errors}
                formData={formData}
                globalAreaType={globalAreaType}
                intersections={projectData?.[STEP_STORAGE_KEYS.INTERSECTIONS]}
                register={register}
              />
              <BottomBar
                handleSecondaryButtonClick={handleButtonClick}
                isFullScreenWidth
                secondaryButtonLabel="Cancel"
                mainButtons={[{ label: "Save" }]}
                projectData={projectData}
                withSubmitButton
                isFormDirty={isDirty}
              />
            </>
          );
        }}
      </StepForm>
    </StepContainer>
  );
}

SafetyDefaults.propTypes = {
  projectData: projectDataPropType.isRequired,
  saveFormData: PropTypes.func.isRequired,
};
